import React, { useState } from "react";
// import { Modal } from "antd"; 
import FeatherIcon from "feather-icons-react";

import { Button } from "../../../../components/buttons/buttons";
import { Modal } from "antd";
import { Form } from "../EmpresaForm";
import { useFetch } from "../../../../hooks/useFetch";

interface ITableButtonEditProps {
  empresaId: string;
  refetch: () => void;
  data: IFetchProps;
}

interface IFetchProps {
  bancoAgencia: string;
  contratoSocial: string;
  idPessoa: string;
  cnpj: string;
  razaoSocial: string;
  bancoConta: string;
  idBanco: string;
  
}

export function TableButtonEdit({ empresaId, refetch, data }: ITableButtonEditProps) {
  const [modalIsOpen, setModalIsOpen] = useState(false);

  return (
    <>
      <Button 
        className="btn-icon" 
        type="info" 
        onClick={() => setModalIsOpen(true)} 
        to="#" 
        shape="circle"
        >
        <FeatherIcon icon="edit" size={16} />
      </Button>

      <Modal
        title="Editar"
        visible={modalIsOpen}
        onCancel={() => setModalIsOpen(false)}
        confirmLoading={true}
        footer={null}
        maskClosable={false}
        width={1200}
        style={{marginTop: -60}}
        bodyStyle={{padding: 0}}
      > 
        <Form 
          formType="put"
          empresaId={empresaId}
          initialFields={{
           

            bancoAgencia: data.bancoAgencia,
            contratoSocial: data.contratoSocial,
            idPessoa: String(data.idPessoa),
            bancoConta: data.bancoConta,
            razaoSocial: data.razaoSocial,
            cnpj: data.cnpj,
            idBanco: String(data.idBanco),
          
          

          }}
          setModalIsOpen={setModalIsOpen} 
          refetch={refetch} 
        />
      </Modal>
    </>
  );
}